export const vehiclesPerMonthOptions = [
	{ text: '0 - 10', value: '0to10' },
	{ text: '10 - 25', value: '10to25' },
	{ text: '25 - 50', value: '25to50' },
	{ text: '50 - 100', value: '50to100' },
	{ text: '100 - 250', value: '100to250' },
	{ text: '250 - 500', value: '250to500' },
	{ text: '500+', value: '500+' },
];

export const distanceOptions = [
	{ text: '0 miles (drop-off only)', value: '0' },
	{ text: 'Up to 10 miles', value: '10' },
	{ text: 'Up to 20 miles', value: '20' },
	{ text: 'Up to 30 miles', value: '30' },
	{ text: 'Up to 50 miles', value: '50' },
	{ text: 'Up to 75 miles', value: '75' },
	{ text: 'Up to 100 miles', value: '100' },
	{ text: 'Up to 200 miles', value: '200' },
	{ text: 'Up to 500 miles', value: '500' },
	{ text: 'Nationwide', value: 'Nationwide' },
];

export const positionOptions = [
	{ text: 'Buyer', value: 'Buyer' },
	{ text: 'CEO / Managing Director', value: 'CEO / Managing Director' },
	{ text: 'Director', value: 'Director' },
	{ text: 'Group Buyer', value: 'Group Buyer' },
	{ text: 'Group Sales Manager', value: 'Group Sales Manager' },
	{ text: 'Owner / Proprietor', value: 'Owner / Proprietor' },
	{ text: 'Sales Manager', value: 'Sales Manager' },
	{ text: 'Stock Controller', value: 'Stock Controller' },
];

export const howHearOptions = [
	{ text: 'Search engine', value: 'Search engine' },
	{ text: 'TV', value: 'TV' },
	{ text: 'Radio', value: 'Radio' },
	{ text: 'Printed advert', value: 'Printed advert' },
	{ text: 'Event', value: 'Event' },
	{ text: 'Word of mouth', value: 'Word of mouth' },
	{ text: 'Other', value: 'Other' },
];

export const companyTypeOptions = [
	{ text: 'Broker', value: 'Broker' },
	{ text: 'Car supermarket', value: 'Car supermarket' },
	{ text: 'Independent', value: 'Independent' },
	{ text: 'Leasing company', value: 'Leasing company' },
	{ text: 'Main dealer (multi-franchise)', value: 'Main dealer multi-franchise' },
	{ text: 'Main dealer (single-franchise)', value: 'Main dealer single-franchise' },
	{ text: 'Manufacturer', value: 'Manufacturer' },
	{ text: 'Online car buyer', value: 'Online car buyer' },
];

export const STATUS = {
	DEFAULT: 'DEFAULT',
	EMAIL_EXISTS: 'EMAIL_EXISTS',
	ERROR: 'ERROR',
	SEND: 'SEND',
	SENDING: 'SENDING',
};

/* eslint-disable sort-keys-fix/sort-keys-fix */
export const FORM_STEPS = {
	DEALER: 'DEALER',
	DEALERSHIP: 'DEALERSHIP',
	REQUIREMENTS: 'REQUIREMENTS',
	COMPLETED: 'COMPLETED',
};
/* eslint-enable sort-keys-fix/sort-keys-fix */
